import React from 'react';
import If from '../If';
import { Backdrop, CloseButton, SimplePopupCard } from '#/app/components/AppMenu/Menu.styles';
import styled from 'styled-components';
import { color } from '@nuvolo/nuux-theme/utils';
import TMMButton from '../TMMButton';
import FAIcon from '#/common/components/FAIcon';

const SlidingPopupLabel = styled.div`
  font-family: Inter, sans-serif;
  font-size: 22px;
  font-weight: 500;
  line-height: 100%;
  letter-spacing: 0;
  color: ${color('secondary', 'dark3')};
  padding: 24px 0;
`;

const SlidingPopupTextArea = styled.div`
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 100%;
  letter-spacing: 0;
  color: ${color('ui', 'dark3')};
  padding-bottom: 24px;
`;

export interface SimplePopupProps {
  width?: string;
  height?: string;
  visible?: boolean;
  onClose?: () => void;
  onSubmit?: () => void;
  title?: React.ReactNode;
  message?: React.ReactNode;
}

const SimplePopup: React.FC<SimplePopupProps> = ({
  width = 'auto',
  height = 'auto',
  visible,
  onClose,
  onSubmit,
  title,
  message,
}) => {
  return (
    <If condition={visible}>
      <Backdrop onClick={onClose} />
      <SimplePopupCard w={width} h={height}>
        {/* Close button */}
        <CloseButton onClick={onClose}>
          <FAIcon icon="xmark" color={color('secondary', 'dark2')} />
        </CloseButton>

        {/* Content */}
        <SlidingPopupLabel>{title}</SlidingPopupLabel>
        <SlidingPopupTextArea>{message}</SlidingPopupTextArea>
        <TMMButton
          key="ok"
          label="Make New Selection"
          type="submit"
          width="100%"
          onClick={onSubmit}
        />
      </SimplePopupCard>
    </If>
  );
};

export default React.memo(SimplePopup);
